<ng-container *vsLet="propertySet$ | async as propertySet">
  <ng-container *vsLet="properties$ | async as properties">
    <ng-container *vsLet="selectedProperty$ | async">
      <vs-input-container
        #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        (click)="toggle()"
        [class]="roundRightBorder ? '' : ' rounded-r-none'"
      >
        <div *ngIf="value?.propertyPath" class="w-fit max-w-[96px] pt-[5px]">
          <vs-badge
            [theme]="selectedPropertyMissing ? 'warn' : 'default'"
            [vsTooltip]="selectedPropertyMissing ? missingPropertyMessage : value!.propertyPath"
            tooltipPosition="top"
            class="w-full h-4"
          >
            <vs-icon *ngIf="selectedPropertyMissing" name="alert-triangle"></vs-icon>
            <span class="w-full truncate">{{ value!.property.name || value!.propertyPath }}</span>
          </vs-badge>
        </div>
        <vs-icon slot="end" name="chevron-down"></vs-icon>
      </vs-input-container>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="overlayOpen"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayFlexibleDimensions]="true"
        [cdkConnectedOverlayViewportMargin]="16"
        (overlayOutsideClick)="$event.stopImmediatePropagation(); overlayOpen = false"
      >
        <vs-menu class="max-h-[300px] overflow-y-auto overscroll-contain">
          <div *ngFor="let property of properties">
            <ws-condition-property-picker-item
              [property]="property"
              [propertyPath]="property.valueKey"
              (selectionChanged)="setValue($event, true); close()"
              [value]="value"
            ></ws-condition-property-picker-item>
          </div>
        </vs-menu>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
